import { SourceEventsToVersion } from "../types/common";
import { AccountingEvent } from "../types/events";
import { PAYMENT_METHODS } from "../constants";
import { mapEmpProviderToPaymentMethod } from "./PaymentUtils";

export const isTvodAccountingEvent = (event: AccountingEvent) => {
  return event.glProductGroup == 318;
};

export const getPaymentMethod = (event: AccountingEvent): string => {
  if (event.isEmpOrder && event.empProviderId) {
    return mapEmpProviderToPaymentMethod(event.empProviderId);
  }

  const paymentId = Object.keys(event.paymentInstruments || {})[0];
  const payment = event.paymentInstruments?.[paymentId];
  switch (payment?.instrument) {
    case "BankAccountPaymentInstrument":
      return PAYMENT_METHODS.DIRECT_DEBIT;
    case "CreditCardPaymentInstrument":
      return PAYMENT_METHODS.CREDIT_CARD;
    default:
      return payment?.instrument ?? PAYMENT_METHODS.AMP;
  }
};

export const getPaymentStatus = (
  sourceEvents: SourceEventsToVersion | undefined,
  isFreeTrial = false
) => {
  if (isFreeTrial) return "in-progress";

  if (Object.keys(sourceEvents || {}).includes("OrderSettleSucceeded"))
    return "success";
  if (
    Object.keys(sourceEvents || {}).includes("OrderCompleted-ClosedNonPayment")
  )
    return "error";
  return "in-progress";
};

export const getPaymentStatusText = (
  sourceEvents: SourceEventsToVersion | undefined,
  method: string,
  isFreeTrial = false
) => {
  if (isFreeTrial) return `Free Trial (${method})`;

  if (Object.keys(sourceEvents || {}).includes("OrderSettleSucceeded"))
    return `Paid (${method})`;
  if (
    Object.keys(sourceEvents || {}).includes("OrderCompleted-ClosedNonPayment")
  )
    return `Failed (${method})`;
  return `Pending (${method})`;
};

export const getFulfillmentStatus = (event: AccountingEvent) => {
  const events = Object.keys(event.sourceEventsToVersion || {});
  switch (true) {
    case !isTvodAccountingEvent(event) &&
      !(events.includes("PeriodStart") || events.includes("Resubscribed")):
    case events.includes("Cancelled"):
      return "error";
    case events.includes("PeriodStart") || events.includes("Resubscribed"):
    case isTvodAccountingEvent(event) &&
      events.includes("OrderCompleted-CompleteSuccess"):
      return "success";
    default:
      return "in-progress";
  }
};

export const getFulfillmentText = (event: AccountingEvent) => {
  const events = Object.keys(event.sourceEventsToVersion || {});
  switch (true) {
    case !isTvodAccountingEvent(event) &&
      !(events.includes("PeriodStart") || events.includes("Resubscribed")):
      return "No Period Start";
    case events.includes("Cancelled"):
      return "Cancelled";
    case events.includes("PeriodStart") || events.includes("Resubscribed"):
    case isTvodAccountingEvent(event) &&
      events.includes("OrderCompleted-CompleteSuccess"):
      return "Fulfilled";
    default:
      return "Pending";
  }
};

export const getRefundStatus = (
  sourceEvents: SourceEventsToVersion | undefined
) => {
  if (Object.keys(sourceEvents || {}).includes("RefundSucceeded"))
    return "success";
  if (Object.keys(sourceEvents || {}).includes("RefundFailed")) return "error";
  return "in-progress";
};

export const getRefundStatusText = (
  sourceEvents: SourceEventsToVersion | undefined
) => {
  if (Object.keys(sourceEvents || {}).includes("RefundSucceeded"))
    return "Refunded";
  if (Object.keys(sourceEvents || {}).includes("RefundFailed"))
    return "Refund Failed";
  return "No Refund";
};

export const hasPromotions = (event: AccountingEvent) =>
  event.discountsOnRevenue && Object.keys(event.discountsOnRevenue).length > 0;
